document.addEventListener('DOMContentLoaded', function () {
  const headerWrapper = document.querySelector('.header-wrapper');
  const menuDetails = document.querySelector('.menu-opening, .header details');

  // Scroll behavior
  window.addEventListener('scroll', function () {
    if (window.scrollY > 50) { // Trigger after scrolling 50px
      headerWrapper.classList.add('scrolled');
    } else {
      headerWrapper.classList.remove('scrolled');
    }
  });

  // Menu open/close behavior with enhanced debugging
  if (headerWrapper) {
    console.log('Header wrapper found:', headerWrapper);
  } else {
    console.error('Header wrapper not found. Check header.liquid.');
  }

  if (menuDetails) {
    console.log('Menu details element found:', menuDetails);
    menuDetails.addEventListener('toggle', function () {
      console.log('Menu toggle event fired, open state:', menuDetails.hasAttribute('open'));
      if (menuDetails.hasAttribute('open')) {
        headerWrapper.classList.add('menu-open');
        console.log('Added menu-open class to header-wrapper');
      } else {
        headerWrapper.classList.remove('menu-open');
        console.log('Removed menu-open class from header-wrapper');
        setTimeout(() => {
          headerWrapper.style.backgroundColor = 'transparent';
        }, 50); // Wait for menu to fully close
      }
    });
  } else {
    console.error('Menu details element not found. Check header.liquid or menu-drawer.liquid.');
  }
});